import { FC } from "react";
import { GiftcardItem, SelectedGiftcard } from "src/store/slices/item/subitems/giftcards.types";
import { Instructions } from "../components";
import GiftcardDetailsCardNew from "../components/GiftcardDetailsCard/GiftcardDetailsCard";
import GiftcardChips from "../components/GiftcardChips/GiftcardChips";
import GiftcardRangeSelector from "../components/GiftcardRangeSelector/GiftcardRangeSelector";
import GiftcardRedeemBar from "../components/GiftcardRedeemBar/GiftcardRedeemBar";

type Props = {
  data: SelectedGiftcard | undefined;
  imageUrl: string | undefined;
  itemCode: string;
  items: GiftcardItem[];
  selectedItemIndex: number;
  setSelectedItemIndex: (i: number) => void;
  brandName?: string;
  range?: { min: number; max: number; value: number };
  onRangeChange: (value: number) => void;
};

const GiftcardDetailsMob: FC<Props> = ({
  data,
  imageUrl,
  itemCode,
  items,
  selectedItemIndex,
  setSelectedItemIndex,
  brandName,
  range,
  onRangeChange,
}) => {
  const isRange = !!range;
  const hasValueSelection = items.length > 1 || isRange;

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="rounded-xs outline-border-subtle flex flex-col overflow-hidden outline">
        <div className="p-4">
          <GiftcardDetailsCardNew data={data} imageUrl={imageUrl} brandName={brandName} />
        </div>
        {hasValueSelection && (
          <div className="flex flex-col gap-4 p-4">
            <GiftcardChips items={items} selectedItemIndex={selectedItemIndex} onSelect={setSelectedItemIndex} />
            {range && <GiftcardRangeSelector min={range.min} max={range.max} value={range.value} currency={data?.currency} onChange={onRangeChange} />}
          </div>
        )}
      </div>
      <Instructions termsAndConditions={data?.termsAndConditions ?? ""} usageInstructions={data?.usageInstructions ?? ""} />
      <div className="shadow-bottom-sheet bg-background-default fixed start-0 end-0 bottom-0 z-50 rounded-t-xl p-4">
        <GiftcardRedeemBar data={data} imageUrl={imageUrl} itemCode={itemCode} />
      </div>
    </div>
  );
};

export default GiftcardDetailsMob;
